// extracted by mini-css-extract-plugin
module.exports = {"spinner":"src-hellospa-components-cross-promo-legal-disclaimer-modal-cross-promo-legal-disclaimer-modal-module__spinner--2jGoE"};